import { render, staticRenderFns } from "./smallCardBox.vue?vue&type=template&id=562dafc8&scoped=true&"
import script from "./smallCardBox.vue?vue&type=script&lang=js&"
export * from "./smallCardBox.vue?vue&type=script&lang=js&"
import style0 from "./smallCardBox.vue?vue&type=style&index=0&id=562dafc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562dafc8",
  null
  
)

export default component.exports